import styles from "../../styles/components/AdminPage.module.css";

export type IssueRecord = {
  sourceId: string;
  count: number;
  lastReportedAt: string;
  errorMessage: string | null;
};

interface Props {
  issues: IssueRecord[] | null;
  loading: boolean;
  deleting: Set<string>;
  onLoad: () => void;
  onDelete: (sourceId: string) => void;
}

export function IssuesTable({ issues, loading, deleting, onLoad, onDelete }: Props) {
  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <h2 className={styles.panelTitle}>Reported Feed Issues</h2>
        <button
          type="button"
          className={`${styles.viewToggleBtn} ${loading ? "" : styles.viewToggleBtnActive}`}
          onClick={onLoad}
          disabled={loading}
        >
          {loading ? "Loading…" : "Load Issues"}
        </button>
      </div>
      <div className={styles.panelBody}>
        {issues === null ? (
          <span className={styles.panelEmpty}>Click "Load Issues" to view reported feed issues.</span>
        ) : issues.length === 0 ? (
          <span className={styles.panelEmpty}>No issues reported yet.</span>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Source ID</th>
                <th>Reports</th>
                <th>Last Reported</th>
                <th>Error Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {issues.map((issue) => (
                <tr key={issue.sourceId}>
                  <td className={styles.tdNarrow}>{issue.sourceId}</td>
                  <td className={styles.tdNarrowCenter}>{issue.count}</td>
                  <td className={styles.tdNarrow}>
                    {new Date(issue.lastReportedAt).toLocaleString()}
                  </td>
                  <td className={styles.tdWrap}>
                    {issue.errorMessage ?? "—"}
                  </td>
                  <td className={styles.tdNarrow}>
                    <button
                      type="button"
                      className={styles.opBtn}
                      disabled={deleting.has(issue.sourceId)}
                      onClick={() => onDelete(issue.sourceId)}
                    >
                      {deleting.has(issue.sourceId) ? "…" : "Clear"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
